import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import Swiper from "swiper";
import { TranslatePipe } from "../pipes/translate.pipe";
import { AppointmentService } from "../services/appointment.service";
import { HomeCareService } from "../services/home-care.service";
import { LinkPatientService } from "../services/link-patient.service";
import { ModalService } from "../services/modal.service";
import { UserService } from "../services/user.service";
import { AWAITINGACTIONICONS } from "@const";
import * as AppConstant from '../app.string';
import  * as _ from 'lodash';
import { CouponService } from "../services/coupon.service";
import { PackageService } from '../services/package.service';

@Component({
  selector: "app-awaiting-actions",
  templateUrl: "./awaiting-actions.component.html",
  styleUrls: ["./awaiting-actions.component.scss"],
})
export class AwaitingActionsComponent implements OnInit, OnDestroy {
  @Input() awaitingList: any;
  @Input() showAsSlide: boolean = false;
  @Output() openSubserviceAppt: EventEmitter<any> = new EventEmitter();
  @Output() action: EventEmitter<any> = new EventEmitter();
  @ViewChild("apptSwiper", { static: false }) apptSwiper: ElementRef;
  private isInitialized: boolean = false;
  private swiper?: Swiper;  
  public couponList:any;
  public isFetchingCoupon:boolean;
  public healthPackages:any;
  public packs: any = [];
  constructor(
    private user: UserService,
    private modalService: ModalService,
    private appointmentService: AppointmentService,
    private couponService: CouponService,
    private packageService: PackageService
  ) {}

  ngOnInit() {
    console.log("awaitingList", this.awaitingList);
    this.getCouponList()

    const data = this.user.getUpdateInfoSync('directives');
    if (data) {
      data.userDefined.find(def => { 
        if(def.directiveGroup == 'HOSPSERV'){
          this.user.setStorage(AppConstant.HEALTHPKG_LIST, JSON.stringify(def));
          
          this.packs.push(_.cloneDeep(def));
          // if(this.packs['concepts'].length >3)
          // this.packs['concepts'].length = 3;
        }
      })
      this.getAllHealthPackages(this.packs)
    }
  }

  ngAfterViewInit() {
    this.initializeSwiper();
  }

  ngOnDestroy() {
    // Clean up Swiper
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }


  private getCouponList(){
    this.couponList=[]
    this.isFetchingCoupon=true;
    let couponParams={
      loyaltyId: this.user.getloyaltyId(),
      isBackgroundProcess: true,
      isPackage: false,
      source: 'DASHBOARD',
      mobile:this.user.getPersonMobile(),
      countryCode:this.user.getPersonCountryCode(),
    }
    this.couponService.getCoupons(couponParams).subscribe(couponData=>{
      this.isFetchingCoupon=false;
      if(couponData?.data.length>0){
        couponData.data.forEach((c)=>{
          c.viewType='PACKAGECOUPON';
        })
        this.couponList = couponData.data;
        this.couponList=this.couponList.filter(c=>{
          if(c['wellnessCouponInfo'])
            return c;
        })
        this.couponList.forEach(c=>{
          c.packageData=this.healthPackages.find(pack => pack?.concept?.code === c['wellnessCouponInfo']['code'])
        })
        console.info('coupon data',this.couponList)
      }
    },error=>this.isFetchingCoupon=false)
  }

  private initializeSwiper() {
    if (this.isInitialized) {
      return; // Already initialized
    }

    // Use timeout to ensure DOM is ready
    setTimeout(() => {
      if (this.apptSwiper?.nativeElement) {
        this.setupSwiper();
        this.isInitialized = true;
      } else {
        // Retry if not ready yet
        this.retryInitialization();
      }
    }, 300);
  }

  private setupSwiper() {
    if (this.apptSwiper?.nativeElement) {
      // Check if already initialized
      if (this.swiper) {
        this.isInitialized = true;
        return;
      }

      const swiperParams = {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets" as const,
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      };

      this.swiper = new Swiper(this.apptSwiper.nativeElement, swiperParams);
      this.isInitialized = true;
      console.log("Swiper initialized for appointments");
    }
  }

  private retryInitialization() {
    let retryCount = 0;
    const maxRetries = 10;

    const retry = () => {
      if (retryCount >= maxRetries) {
        console.warn("Failed to initialize Swiper after maximum retries");
        return;
      }

      setTimeout(
        () => {
          if (this.apptSwiper?.nativeElement) {
            this.setupSwiper();
            this.isInitialized = true;
          } else {
            retryCount++;
            retry();
          }
        },
        100 * (retryCount + 1),
      ); // Exponential backoff
    };

    retry();
  }

  public seeAll() {
    this.action.emit()
  }


  public getIcon(item){
      let cardType = item?.viewType || 'AWAITINGLISTAPPTS';
      let iconsObj = (cardType == 'AWAITINGLISTAPPTS' || cardType == 'PACKAGECOUPON')? AWAITINGACTIONICONS : AWAITINGACTIONICONS;
    
    return iconsObj[item?._icon || 'LAB']
  }

  public openBookSubsequentAppt(item) {
    this.openSubserviceAppt.emit(item);
  }

  private getAllHealthPackages(packs) {
    let healthPackages = packs || [];
    console.info('healthPackages', healthPackages);
    let allPackages = []
    let packages = allPackages?.length ? allPackages : healthPackages
    this.packageService.setAllPackages(packages);
    console.info('packages>>>>>', packages);
    let reducedHealthPackages = packages.reduce((r, a) => {
      let pack, concepts = [];
      if (a._directiveRef) {
        pack = _.cloneDeep(a._directiveRef);
        delete a._directiveRef
        concepts = [a];
      } else {
        pack = a;
        concepts = a.concepts;
      }
      let packHead = {
        code: pack.code,
        directiveGroup: pack.directiveGroup,
        facilities: pack.facilities,
        sysDef: pack.sysDef,
        name: pack.name,
        imageUrl: pack.imageUrl,
        expanded: pack.expanded,
        canRequest: pack.canRequest,
        isPackageApplicable:pack.isPackageApplicable
      }
      concepts.forEach(concept => {
        if(concept && concept['name'] && concept['name'].length > 0){
          let _name = concept['name'].find(t => {
            return t.locale == this.user.getCurrentLanguage()
          })
          concept['pkgName'] = _name ? _name['name'] : ""
        }else {
          concept['pkgName'] = concept['name'] ? concept['name'] : ""
        }
        if (concept.packageDtls && (concept.packageDtls.isPackageApplicable && concept.packageDtls.isPackageApplicable == 'Y')) {
          r.push({
            package: _.cloneDeep(packHead),
            concept: _.cloneDeep(concept)
          })
        }
      })
      return r;
    }, [])
    //hardcoded HLTHPKGS directive only to show in home page as display priority changes not included in 8.1.9.0
    reducedHealthPackages = reducedHealthPackages.filter(p => (p.package && p.package.isPackageApplicable && p.package.isPackageApplicable == 'Y')).sort((a, b) => {a['_displayPriority']-b['_displayPriority']})
    reducedHealthPackages = _.orderBy(reducedHealthPackages, ["concept['_displayPriority']", "concept['pkgName']"], ["asc", "asc"])
    console.info('reducedHealthPackages', reducedHealthPackages)
    this.healthPackages = reducedHealthPackages;
  }
}
